export const routes = {
  home: "/",
  shop: "/shop",
  about: "/about",
  delivery: "/delivery-returns",
  faq: "/faq",
  productHtml: "/product.html",
  contact: "/pages/contact.html",
  privacy: "/pages/privacy.html",
  terms: "/pages/terms.html",
  notFound: "/404.html"
} as const;

export function shopCategoryPath(categoryId: string) {
  return `${routes.shop}?category=${encodeURIComponent(categoryId)}`;
}

export function productPath(slug: string) {
  return `/products/${encodeURIComponent(slug)}`;
}

export const htmlRedirects = [
  { from: "shop.html", to: routes.shop },
  { from: "pages/about.html", to: routes.about },
  { from: "pages/delivery-returns.html", to: routes.delivery },
  { from: "pages/faq.html", to: routes.faq }
] as const;
